import {Component, OnInit} from '@angular/core';
import {TourFundBonusService} from '../../../shared/services/tour-fund-bonus.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-tour-fund-bonus',
  templateUrl: './tour-fund-bonus.component.html',
  styleUrls: ['./tour-fund-bonus.component.scss']
})
export class TourFundBonusComponent implements OnInit {
  submitting = false;
  tourFundBonus = [];
  total: any = 0;
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public tourFundBonusService: TourFundBonusService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'transaction_no': [''],
      'sender_id': [''],
      'commission': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.tourFundBonus = [];
    this.tourFundBonusService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.tourFundBonus = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.total = data.total_commission;
        this.triggerScroll();
      } else {
        this.tourFundBonus = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'transaction_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.transaction_no : '',
      'sender_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.sender_id : '',
      'commission': (this.searchForm && this.searchForm.value) ? this.searchForm.value.commission : '',
    };
    this.get(params);
  }
}
